import InputHeader from "../input/InputHeader";
import InputCard from "../containers/InputCard";
import InfoLabel from "./InfoLabel";

const CurrentUser = () => {
  return (
    <InputCard>
      <InputHeader text="Audit Date" />
      <InfoLabel identifier="currentDate" text={new Date().toLocaleString()} />
    </InputCard>
  );
};

export default CurrentUser;
